// extracted by mini-css-extract-plugin
export default {"input":"PhoneForm_input__A2DCa","input_error":"PhoneForm_input_error__RklGM"};